import throwIfError from '@/lib/api/throwIfError'
import type {SupportedLocales} from '@/lib/locale/locale'
import {
  type StoreApiResponse,
  StoreApiResponseSchema,
  type StoresApiResponse,
  StoresApiResponseSchema,
} from '@/models/storeModel'
import call from '@/utils/api/call'
import shouldLogError from '@/utils/api/shouldLogError'
import UnexpectedError from '@/utils/api/UnexpectedError'

export async function getStore({
  storeId,
  locale,
  signal,
}: {
  storeId: string
  locale: SupportedLocales
  signal?: AbortSignal
}): Promise<StoreApiResponse> {
  const url = `/api/model/store/${encodeURIComponent(storeId)}/`
  return call
    .post<unknown>(
      url,
      {
        localization: {
          locale,
        },
      },
      {signal},
    )
    .then(res => {
      throwIfError(res, [])
      const result = StoreApiResponseSchema(res.data)
      return result
    })
    .catch(e => {
      if (shouldLogError(e)) {
        console.error('Cannot fetch store', e)
      }
      throw new UnexpectedError(e)
    })
}

export async function getStores({
  locale,
  signal,
}: {
  locale: SupportedLocales
  signal?: AbortSignal
}): Promise<StoresApiResponse> {
  const url = `/api/model/stores/`
  return call
    .post<unknown>(
      url,
      {
        localization: {
          locale,
        },
      },
      {signal},
    )
    .then(res => {
      throwIfError(res, [])
      const result = StoresApiResponseSchema(res.data)
      return result
    })
    .catch(e => {
      if (shouldLogError(e)) {
        console.error('Cannot fetch stores', e)
      }
      throw new UnexpectedError(e)
    })
}
